import { Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import TableContainerMin from "../../../../common/TableContainerMin";
import '../utils/style.css';
import '../utils/detail.css';
import { getRechargeBankTransfer } from "../services/developerApi";
import { FormatCurrency } from "../../../../common/format/formatCurrency";
import DetailRechargeBank from "./rechargeCompte";
const RechargeCompteBusiness = ({id,developer,onRefresh,})=>{
const [selectedBusiness, setSelectedBusiness] = useState(null);
const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
const [rechargeCompte, setCompteRecharge] = useState([]);
const [isModalOpen, setIsModalOpen] = useState(false);
const filteredRecharge = rechargeCompte?.filter((developer) => {
  let match = true;
  if (searchTerm) {
    const name = developer?.mandatoryTransferReference || "";
    match = name.toLowerCase().includes(searchTerm.toLowerCase());
  }
  if (filterValues?.transactionReference) {
    match = match && developer.transactionReference === filterValues.transactionReference;
  }
  if (filterValues?.mandatoryTransferReference) {
    match = match && developer.mandatoryTransferReference === filterValues.mandatoryTransferReference;
  }
  if (filterValues?.status) {
    match = match && developer.status === filterValues.status;
  }
  return match;
});
const [loading, setLoading] = useState(false);

 const fetchRechargeBankTransfer = async () => {
  setLoading(true);
  try {
    const res = await getRechargeBankTransfer(
      developer?.apiKey,
      developer?.apiToken
    );
    const data = res?.data || [];
    setCompteRecharge(
      Array.isArray(data) ? data : []
    );

  } catch (error) {
    console.error("❌ ERREUR API:", error);
    setCompteRecharge([]);

  } finally {
    setLoading(false);
  }
};

useEffect(() => {

  if (
    developer?.apiKey &&
    developer?.apiToken
  ) {
    fetchRechargeBankTransfer();
  }

}, [developer]);
 const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const mobileColumns = [
  {
    Header: "Client",
    accessor: "merchantAccountName",
  },
  {
  Header: "Date",
  accessor: "createdAt",
  Cell: ({ value }) =>
    new Date(value).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }),
},
 {
  Header: "Méthode de paiement",
  accessor: "account",
  Cell: ({ value }) => value || "Virement bancaire",
},
   {
    Header: "Montant",
    accessor: "amount",
    Cell: ({ row }) => 
      `${FormatCurrency( row.original.amount)}`,
    
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => renderStatusBadge(value),
  },
      {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div  className="consulter"
              onClick={(e) => {
          e.stopPropagation();
          setSelectedBusiness(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true); 
        }}>
             consulter
            </div>
          </div>
        );
      },
      filterable: false,
    },
];
const columns =
mobileColumns;
const renderStatusBadge = (status) => {
  let label = "Inconnu";
  let icon = "❓";
  const style = {
    backgroundColor: "#FFEFD5",
    color: "#000",
    padding: "1px 6px",
    borderRadius: "100px",
    fontWeight: 400,
    fontSize: "13px",
    fontStyle: "Medium",
    display: "inline-block"
  };
  if (status === "APPROVED"){
    label = "Confirmé"
    icon = "✓";
    style.backgroundColor = "#EBFFEA";
    style.color = "#349C32";
  } else if (status === "WAITING_PROOF"){
    label = "Documents requis"
    icon = "📎"
    style.backgroundColor = "#F6F6F6";
    style.color = "#000000";
  }
  else if (status === "SUCCESS" ) {
    label = "Succés"
     icon = "✓";
    style.backgroundColor = "#EBFFEA";
     style.color = "#349C32";
  }
   else if (status === "APPROVED"){
    label = "Confirmé";
     icon = "✓";
    style.backgroundColor = "#EBFFEA";
     style.color = "#349C32";
  }
  else if (status === "PENDING_REVIEW"){
    label = "En attente de validation"
     icon = "⌛";
    style.backgroundColor = "#FBF3FF";
     style.color = "#9315D6";
  }
else if (status === "REJECTED" ) {
    label = "Echec";
     icon = "❌";
    style.backgroundColor = "#FFF0F0";
     style.color = "#D41C1C";
  }
  return <span style={style}>{icon} {label}</span>;
};
return(
  <>
<div className="versement-toolbar mb-3"
  style={{maxWidth: "",marginTop: "12px",gap: "10px",}}>
  <input
    type="text"
    placeholder="Recherche une demande de chargement..."
    className="form-control"
   style={{ width: "100%" }}
    onChange={(e) => setSearchTerm(e.target.value)}
    value={searchTerm}
  />
  <Button
    className="filtrer"
    style={{ display: "flex", alignItems: "center", gap: "8px" }}
  >
    <img src={filter} alt="Filtrer" style={{ width: "20px", height: "20px" }} />
    Filtrer
  </Button>
      </div>  
      <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        {loading ? (
     <div style={{ textAlign: "center", padding: "20px" }}>
    ⏳<Spin/>
  </div>
) : (
  <TableContainerMin
    columns={columns}
    data={filteredRecharge}
    isGlobalFilter={false}
    customPageSize={10}
    className="custom-header-css"
    divClass="table-responsive"
    tableClass="table w-100 mb-0 no-column-borders"
    theadClass="custom-thead"
    SearchPlaceholder="Recherche..."
    // HeaderTable={HeaderTable}
  />
)}    
  {filteredRecharge && filteredRecharge.length === 0 && !loading && (
     <div
        style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 0"
      }}
    >
   <div style={{ textAlign: "center", padding: "20px" }}>
    📭 Aucune demande de transfert trouvé
  </div>
</div>
  )}
  </CardBody>
  </Card>
  </Col>
</Row>
<DetailRechargeBank
  isOpen={isModalOpen}
  toggle={() => setIsModalOpen(false)}
  selectedBusiness={selectedBusiness}
  onRefresh={fetchRechargeBankTransfer}
/> </>
);
}
export default RechargeCompteBusiness;
